'use client';

import {
  IconBuildingStore,
  IconCalendarWeek,
  IconMapPin,
} from '@tabler/icons-react';
import {
  Box,
  Button,
  Group,
  Paper,
  Skeleton,
  Stack,
  StackProps,
  Text,
  ThemeIcon,
} from '@mantine/core';
import { DayWeekLabel } from '@/src/models/outlet-detail';
import useModuleOutlet from '@/src/modules/marketplace/outlet';
import {
  formatSchedule,
  getSortedSchedule,
} from '@/src/modules/outlets/utils/common';
import { Layanan } from './Layanan';
import { Produk } from './Produk';

interface ITabBerandaProps {
  goToProduk: () => void;
  goToLayanan: () => void;
}

const outletDescriptionFieldProps: StackProps = {
  display: { base: 'flex', md: 'table-row' },
  gap: 0,
};

export function TabBeranda({ goToProduk, goToLayanan }: ITabBerandaProps) {
  const { outlet } = useModuleOutlet();
  const sortedSchedule = getSortedSchedule(outlet?.operational_schedule);

  return (
    <div className="flex flex-col gap-6">
      {/* Carousel */}

      <div className="">
        {/*<Carousel
          height={250}
          slideSize="100%"
          slideGap="md"
          emblaOptions={{
            loop: true,
            dragFree: false,
            align: 'start',
          }}
          classNames={{
            indicator: 'bg-white/50 data-[active]:bg-white',
            control: 'bg-white/20 hover:bg-white/40 text-white border-none',
          }}
        >
          <Carousel.Slide key={0}>
            <Paper
              radius="md"
              className="bg-gradient-to-r from-teal-500 to-cyan-600 h-full overflow-hidden relative flex items-center"
            >
              <div
                className="absolute inset-0 opacity-20 bg-cover bg-center"
                style={{
                  backgroundImage: `url(https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=1200&h=400)`,
                }}
              />
              <div className="p-12 md:p-14 flex items-center justify-between relative z-10 w-full h-full">
                <div className="text-white max-w-2xl">
                  <div className="mb-2">
                    <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm">
                      PROMO SPESIAL
                    </span>
                  </div>
                  <Title order={2} mb="xs" className="text-white drop-shadow-sm">
                    MEDICOOL with Dr. Miranda
                  </Title>
                  <Text mb="lg" size="lg" className="text-white opacity-95 drop-shadow-sm">
                    Pelajari topik kesehatan terkini langsung dari ahlinya.
                  </Text>
                  <Button variant="white" color="dark" radius="md">
                    Lihat Detail
                  </Button>
                </div>
              </div>
            </Paper>
          </Carousel.Slide>
          <Carousel.Slide key={1}>
            <Paper
              radius="md"
              className="bg-gradient-to-r from-orange-500 to-red-500 h-full overflow-hidden relative flex items-center"
            >
              <div
                className="absolute inset-0 opacity-20 bg-cover bg-center"
                style={{
                  backgroundImage: `url(https://images.unsplash.com/photo-1585435557343-3b092031a831?auto=format&fit=crop&q=80&w=1200&h=400)`,
                }}
              />
              <div className="p-8 md:p-12 flex items-center justify-between relative z-10 w-full">
                <div className="text-white max-w-2xl">
                  <div className="mb-2">
                    <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-semibold backdrop-blur-sm">
                      DISKON SPESIAL
                    </span>
                  </div>
                  <Title order={2} mb="xs" className="text-white drop-shadow-sm">
                    Diskon Spesial Vitamin
                  </Title>
                  <Text mb="lg" size="lg" className="text-white opacity-95 drop-shadow-sm">
                    Jaga daya tahan tubuh dengan vitamin pilihan.
                  </Text>
                  <Button variant="white" color="dark" radius="md">
                    Lihat Detail
                  </Button>
                </div>
              </div>
            </Paper>
          </Carousel.Slide>
        </Carousel>*/}
      </div>

      {/* Promo */}
      {/* <div className="py-2">
                <Group justify="space-between" mb="md">
                    <Title order={3} size="h4">Promo</Title>
                    <Button variant="subtle" size="sm">Lihat Semua</Button>
                </Group>
                <Grid>
                    <Grid.Col span={{ base: 12, sm: 6 }}>
                        <Paper p="md" radius="md" className="bg-orange-50 border border-orange-100 h-full">
                            <Text fw={700} c="orange.8" size="lg">Cashback Rp 50.000</Text>
                            <Text size="sm" c="dimmed">Pemesanan Pertama pelayanan Home Service</Text>
                        </Paper>
                    </Grid.Col>
                    <Grid.Col span={{ base: 12, sm: 6 }}>
                        <Paper p="md" radius="md" className="bg-orange-50 border border-orange-100 h-full">
                            <Text fw={700} c="orange.8" size="lg">Cashback Rp 30.000</Text>
                            <Text size="sm" c="dimmed">Seluruh pembelian kategori Home Service</Text>
                        </Paper>
                    </Grid.Col>
                </Grid>
            </div> */}
      {/* Lokasi Praktik */}
      <Paper p="md" radius="lg" withBorder>
        <Group align="flex-start" wrap="nowrap" justify="space-between">
          {/* Left: Location info */}
          <Group align="flex-start" wrap="nowrap" w="100%">
            <ThemeIcon size="lg" radius="md" color="brand" mt={4}>
              <IconMapPin size={20} />
            </ThemeIcon>

            <Stack gap="0.3rem" w="100%">
              <Group justify="space-between" align="start">
                <Text fw={700} size="md">
                  Lokasi
                </Text>

                {(!outlet?.latitude || !outlet?.longitude) && (
                  <Skeleton height={25} width="10%" radius="xl" />
                )}

                {outlet?.latitude && outlet?.longitude && (
                  <Button
                    variant="outline"
                    radius="xl"
                    size="xs"
                    component="a"
                    href={`https://www.google.com/maps?q=${outlet.latitude},${outlet.longitude}`}
                    target="_blank"
                    w="fit-content"
                    visibleFrom="lg"
                  >
                    Lihat Lokasi
                  </Button>
                )}
              </Group>

              {!outlet?.address ? (
                <Skeleton height={16} width="70%" radius="sm" />
              ) : (
                <Text size="sm" c="dimmed">
                  {outlet.address}
                </Text>
              )}

              {outlet?.latitude && outlet?.longitude && (
                <Button
                  variant="outline"
                  radius="xl"
                  size="xs"
                  component="a"
                  href={`https://www.google.com/maps?q=${outlet.latitude},${outlet.longitude}`}
                  target="_blank"
                  w="fit-content"
                  mt="sm"
                  hiddenFrom="lg"
                >
                  Lihat Lokasi
                </Button>
              )}
            </Stack>
          </Group>
        </Group>
      </Paper>

      {sortedSchedule && sortedSchedule.length > 0 && (
        <Paper p="md" radius="lg" withBorder>
          <Group
            align="flex-start"
            wrap="nowrap"
            justify="space-between"
            w="100%"
          >
            {/* Left: Operational Schedule Outlet */}
            <Group align="flex-start" wrap="nowrap" w="100%">
              <ThemeIcon size="lg" radius="md" color="brand" mt={4}>
                <IconCalendarWeek size={20} />
              </ThemeIcon>
              <Stack gap="0.3rem" w="100%">
                <Text fw="bold" size="md">
                  Jadwal Operasional
                </Text>
                <Box display="table" className="border-spacing-y-1.5">
                  {!sortedSchedule || sortedSchedule.length === 0 ? (
                    <>
                      {[1, 2, 3, 4, 5, 6, 7].map((_, idx) => (
                        <Group key={idx} wrap="nowrap">
                          <Skeleton
                            height={16}
                            width="20%"
                            mt="sm"
                            radius="sm"
                          />
                        </Group>
                      ))}
                    </>
                  ) : (
                    sortedSchedule.map((item) => (
                      <Group
                        display="table-row"
                        key={item.DayWeek}
                        align="left"
                        wrap="nowrap"
                      >
                        <Text
                          w={100}
                          fz="sm"
                          fw={500}
                          c="dimmed"
                          display="table-cell"
                        >
                          {DayWeekLabel[item.DayWeek]}
                        </Text>

                        <Text fz="sm" display="table-cell">
                          {formatSchedule(item)}
                        </Text>
                      </Group>
                    ))
                  )}
                </Box>
              </Stack>
            </Group>
          </Group>
        </Paper>
      )}

      <Paper p="md" radius="lg" withBorder>
        <Group
          align="flex-start"
          wrap="nowrap"
          justify="space-between"
          w="100%"
        >
          {/* Left: Description info */}
          <Group align="flex-start" wrap="nowrap" w="100%">
            <ThemeIcon size="lg" radius="md" color="brand" mt={4}>
              <IconBuildingStore size={20} />
            </ThemeIcon>

            <Stack gap="0.3rem" w="100%">
              <Text fw="bold" size="md">
                Deskripsi
              </Text>

              <Stack
                display={{ base: 'flex', md: 'table' }}
                gap="xs"
                className="border-spacing-y-1.5"
              >
                <Stack {...outletDescriptionFieldProps}>
                  <Text size="sm" fw={500} display="table-cell" c="dimmed">
                    Apoteker
                  </Text>
                  {!outlet?.pharmacist ? (
                    <Skeleton height={16} width={150} radius="sm" />
                  ) : (
                    <Text size="sm" display="table-cell">
                      {outlet?.pharmacist}
                    </Text>
                  )}
                </Stack>

                <Stack {...outletDescriptionFieldProps}>
                  <Text size="sm" fw={500} display="table-cell" c="dimmed">
                    Nomor SIA
                  </Text>
                  {!outlet?.sia ? (
                    <Skeleton height={16} width={150} radius="sm" />
                  ) : (
                    <Text size="sm" display="table-cell">
                      {outlet?.sia}
                    </Text>
                  )}
                </Stack>

                <Stack {...outletDescriptionFieldProps}>
                  <Text size="sm" fw={500} display="table-cell" c="dimmed">
                    Nomor SIPA
                  </Text>
                  {!outlet?.sipa ? (
                    <Skeleton height={16} width={150} radius="sm" />
                  ) : (
                    <Text size="sm" display="table-cell">
                      {outlet?.sipa}
                    </Text>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Group>
        </Group>
      </Paper>

      {/* Rekomendasi Produk */}
      <Produk
        outlet_id={outlet?.branch_point_id ?? 0}
        offset={1}
        size={4}
        goToProduk={goToProduk}
        showHeader
      />

      {/* Rekomendasi Layanan*/}
      <Layanan
        outlet_id={outlet?.branch_point_id ?? 0}
        offset={1}
        size={4}
        goToLayanan={goToLayanan}
        showHeader
      />

      {/* Deskripsi Toko */}
      {/*<Paper
        p="md"
        radius="lg"
        withBorder
      >
        <Group
          align="flex-start"
          wrap="nowrap"
        >
          <ThemeIcon
            size="lg"
            radius="md"
            variant="gradient"
            gradient={{ from: 'indigo', to: 'violet' }}
          >
            <IconBrandAppgallery size={20} />
          </ThemeIcon>

          <div>
            <Text
              fw={700}
              size="md"
            >
              Deskripsi Toko
            </Text>
            <Text
              size="sm"
              c="dimmed"
              mt={2}
            >
              {outlet?.description ??
                'Menyediakan pelayanan dan produk terbaik untuk seluruh warga negara Indonesia'}
            </Text>
          </div>
        </Group>
      </Paper>*/}

      {/* Produk Rekomendasi */}
      {/* <div>
                <Group justify="space-between" mb="md">
                    <Title order={3} size="h4">Produk Rekomendasi</Title>
                    <Button variant="subtle" size="sm">Lihat Semua</Button>
                </Group>
                <SimpleGrid cols={{ base: 2, sm: 3, md: 4 }} spacing="md">
                    {MOCK_PRODUCTS.map((product, index) => (
                        <ItemCard key={index} {...product} />
                    ))}
                </SimpleGrid>
            </div> */}

      {/* Layanan Rekomendasi */}
      {/* {listService && (
        <Stack>
          <Title
            order={3}
            size="h4"
          >
            Layanan Rekomendasi
          </Title>
          <SimpleGrid
            cols={{ base: 2, sm: 3, md: 4 }}
            spacing="md"
          >
            {listService?.map((row, index) => (
              <LayananGrid
                key={index}
                row={row}
                outletId={outlet!.id.toString()}
              />
            ))}
          </SimpleGrid>
        </Stack>
      )} */}

      {/* Ulasan Pasien */}
      {/*<div>
        <Title
          order={3}
          size="h4"
          mb="xs"
        >
          Ulasan Pasien
        </Title>
        <Group
          gap="xs"
          mb="md"
        >
          <Rating
            value={4.5}
            readOnly
            size="sm"
          />
          <Text
            size="sm"
            fw={500}
          >
            4.5 (1,6 rb Pasien)
          </Text>
        </Group>

        <div className="flex flex-col gap-4">
          {[1, 2].map((_, i) => (
            <Paper
              key={i}
              p="md"
              radius="md"
              withBorder
            >
              <Group mb="xs">
                <Avatar
                  src={`https://i.pravatar.cc/150?u=${i}`}
                  radius="xl"
                />
                <div>
                  <Text
                    size="sm"
                    fw={600}
                  >
                    Amanda
                  </Text>
                  <Rating
                    value={5}
                    readOnly
                    size="xs"
                  />
                </div>
              </Group>
              <Text
                size="sm"
                c="dimmed"
              >
                Lorem ipsum dolor sit amet consectetur. Sit ante neque proin
                eget mauris ac velit ultrices. Sit fermentum nisl volutpat
                volutpat.
              </Text>
            </Paper>
          ))}
        </div>
      </div>*/}
    </div>
  );
}
